import { Link } from "react-router";

import "./about-growthspurt.css";

export default function AboutGrowthSpurt() {
    return (
        <div id="about-page">
            <div id="about-wrapper" className="container">
            
            <h1>Growth Spurt Interface</h1>
            <p>Welcome to the Growth Spurt Interface! This is a tool designed to help you manage and visualize your growth spurt data.</p>
            <Link to="/">
                    <div className="app-link" id="home-button">
                        Return to Home
                    </div>
                </Link>
            </div>
        </div>
    );
}